var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57756 1.99981L14.9282 12.9998C14.9867 13.1012 15.0175 13.2161 15.0175 13.3331C15.0175 13.4502 14.9867 13.5651 14.9282 13.6665C14.8697 13.7678 14.7856 13.852 14.6842 13.9105C14.5829 13.969 14.4679 13.9998 14.3509 13.9998H1.64956C1.53254 13.9998 1.41758 13.969 1.31623 13.9105C1.21489 13.852 1.13073 13.7678 1.07222 13.6665C1.01371 13.5651 0.982909 13.4502 0.98291 13.3331C0.982911 13.2161 1.01372 13.1012 1.07223 12.9998L7.42289 1.99981C7.48141 1.89847 7.56557 1.81432 7.66691 1.75581C7.76825 1.6973 7.88321 1.6665 8.00023 1.6665C8.11725 1.6665 8.2322 1.6973 8.33355 1.75581C8.43489 1.81432 8.51905 1.89847 8.57756 1.99981ZM7.33356 10.6665V11.9998H8.66689V10.6665H7.33356ZM7.33356 5.99981V9.33314H8.66689V5.99981H7.33356Z",
    fill: "#EF8D07"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.ceedce424ff6de1c33fc06ad8fc06086.svg";
export { ForwardRef as ReactComponent };